import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { getProductPrices } from "../productList/utils";
import ProductImageGallery from "./ProductImageGallery";
import ProductDescriptionInfoSlider from "./ProductDescriptionInfoSlider";

const ProductImageDescription = ({ product, currency, cartItems, wishlistItems, compareItems }) => {
    const wishlistItem = wishlistItems.filter((wishlistItem) => wishlistItem.id === product.id)[0];
    const compareItem = compareItems.filter((compareItem) => compareItem.id === product.id)[0];
    const { discountedPrice, finalProductPrice, finalDiscountedPrice } = getProductPrices(
        product.price,
        product.discount,
        currency.currencyRate,
    );

    return (
        <div className="shop-area pt-100 pb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        {/* product image gallery */}
                        <ProductImageGallery product={product} />
                    </div>
                    <div className="col-lg-6 col-md-6">
                        {/* product description info */}
                        <ProductDescriptionInfoSlider
                            product={product}
                            discountedPrice={discountedPrice}
                            currency={currency}
                            finalDiscountedPrice={finalDiscountedPrice}
                            finalProductPrice={finalProductPrice}
                            cartItems={cartItems}
                            wishlistItem={wishlistItem}
                            compareItem={compareItem}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductImageDescription.propTypes = {
    cartItems: PropTypes.array,
    compareItems: PropTypes.array,
    currency: PropTypes.object,
    product: PropTypes.object,
    wishlistItems: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        currency: state.currencyData,
        cartItems: state.cartData,
        wishlistItems: state.wishlistData,
        compareItems: state.compareData,
    };
};

export default connect(mapStateToProps)(ProductImageDescription);
